import { useContext, } from 'react';

import UserContext from '../contexts/user';

export default _ => useContext(UserContext);
